<template>
<div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="width:100%;height:40px;margin-bottom:10px;">
        <div class="top_buttons">
            <el-button icon="el-icon-download" type="primary" @click="export_progress">导出进展</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-message" type="warning" @click="send_emails">邮件跟催</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-setting" type="warning" @click="Reset_user_passwd">重置密码</el-button>
        </div>
    </div>
    <el-dialog class="reset_passwd_dialog" title="重置密码" :visible.sync="dialogFormVisible_resetpasswd" width="400px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
        <el-select v-model="reset_username" placeholder="请选择待重置密码的邮箱" style="width:260px;" clearable>
            <el-option
            v-for="item in reset_user_list"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
        <!-- <el-input v-model="reset_username" placeholder="请输入登录邮箱地址"></el-input> -->
        <div style="text-align:center;line-height:40px;">
            <el-button @click="cancle_reset">取 消</el-button>
            <el-button type="primary" @click="submit_reset" style="margin-top:30px;">确 定</el-button>
        </div>
    </el-dialog> 
</div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        getdata.getList("checklogin")
              .then((resp) => {
                this.task_id = resp.data.task_id;
                // 当前页面仅限企业用户登录
                if(resp.data.usertype!='company'){
                    this.$router.push({
                    path: '/404',
                });
                }
              })
              .catch(() => {
                // if(localStorage.getItem("token") != null){
                //     this.$message({
                //         message: '会话超时，请重新登录！',
                //         type: 'warning',
                //     })
                // }
                this.$router.push({
                    path: '/login',
                });
              })
    },
    data() {
        return {
            task_id: null,
            template_file: {
                file_name: 'Assessment_progress.xlsx'
            },
            dialogFormVisible_resetpasswd: false,
            reset_username: '',
            reset_user_list: [],
        };
    },
    methods: {
        Reset_user_passwd() {
            let params = {
                'task_id': this.task_id,
            };
            getdata.getListP("getUserList", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.reset_user_list = resp.data.data;
                    this.dialogFormVisible_resetpasswd = true;
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }
            })
            .catch(() => {

            });
        },
        cancle_reset() {
            this.dialogFormVisible_resetpasswd = false;
        },
        submit_reset() {
            if(this.reset_username == ''){
                this.$message({
                    message: "请选择待重置密码的邮箱！",
                    type: "error",
                    duration: 6000,
                })
            }else{
                let params = {
                    'username': this.reset_username,
                    'task_id': this.task_id,
                };
                getdata.getListP("resetPasswdToDefault", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            this.dialogFormVisible_resetpasswd = false;
                        }else{
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                    })
                    .catch(() => {

                    });
            }
        },
        send_emails() {
            let params;
            params = {
                task_id: this.task_id,
            }
            getdata.getListP("sendEmails", params)
              .then((resp) => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: "success",
                    })
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }})
              .catch(err => {
                console.log(err);
              }) 
        },
        export_progress() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportProgressByUsers", JSON.stringify(this.template_file), params)
              .then(resp => {
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
    }
}
</script>

<style scoped>
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.top_buttons > .el-button {
    font-size: 16px;
}
</style>

